import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getChurchTeams = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/dashboard/church-teams`);
};

export const useChurchTeams = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["church-teams", churchId],
    queryFn: () => getChurchTeams({ churchId }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
